<template>
	<div>
		<div class="search">
			<div class="block">
				<el-date-picker
					v-model="timer"
					:default-time="['00:00:00', '23:59:59']"
					value-format="timestamp"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					clearable
					style="width: 400px;"
				></el-date-picker>
			</div>
			<div class="block"><el-button type="primary" @click="getDate()">搜索</el-button></div>
		</div>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" height='calc(100vh - 250px)'>
			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column prop="user.name" label="申请用户"></el-table-column>
			<el-table-column label="申请结算金额">
				<template slot-scope='scope'>
					<span class="yellow">{{scope.row.detail.amount/100}} 元</span>
				</template>
			</el-table-column>
			<el-table-column label="申请时间">
				<template slot-scope='scope'>
					{{setTime(scope.row.detail.createAt)}}
				</template>
			</el-table-column>
			<el-table-column label="状态">
				<template slot-scope='scope' >
          <span v-if="scope.row.detail.status == 1">申请中</span>
          <span v-else-if="scope.row.detail.status == 2">结算</span>
          <span v-else>已拒绝</span>
				</template>
        
			</el-table-column>
			<el-table-column label="备注">
				<template slot-scope='scope'>
					<span>{{ (scope.row.detail.remark === null || scope.row.detail.remark === undefined || scope.row.detail.remark === '') ? '暂无' : scope.row.detail.remark }}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope='scope'>
					<el-button type="text" :disabled="scope.row.detail.status == 3" @click='centerDialogVisible = true;listId=scope.row.detail.id;listMoney=scope.row.detail.amount'>上传发票</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="fenye">
			<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
		</div>
    <el-dialog title="发票上传说明" :visible.sync="centerDialogVisible" width="800" center top="1vh">
      <fpPop :listId='listId' :listMoney='listMoney' @setState='setState'></fpPop>
    </el-dialog>
	</div>
</template>

<script>
import { settlementList } from '@/axios/api'
import common from '@/assets/common.js'
import fpPop from './fpPop'
export default {
	data() {
		return {
			  timer: null,
			  tableData: [],
			  allpage:10,
			  centerDialogVisible:false,
			  listId:'',
			  listMoney:''
		    };
	},
	components:{
		fpPop
	},
	methods: {
		setState(){
		this.centerDialogVisible=false
		},
		changePage(start,count){
			this.getDate(start,count)
		},
		setTime(str){
			return common.time(str)
		},
		getDate(start,count) {
			var data={}
			if(this.timer){
				data={
					start:start||0,
					count:count||10,
					startts:this.timer[0],
					endts:this.timer[1]
				}
			}else{
				data={
					start:start||0,
					count:count||10
				}
			}
			settlementList(data)
			.then(res => {
				console.log(res)
				this.tableData=res.data.obj;
				this.allpage=res.data.obj2;
			})
			.catch( err => {
				console.log(err)
			})
		}
	},
	mounted(){
		this.getDate()
	}
};
</script>

<style scoped="scoped">
.search {
	overflow: hidden;
	margin-top: 20px;
}

.search .block {
	float: left;
	margin-right: 10px;
}

.sss {
	width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/list.vue